const locale = {
  setColumnButtonTip: '表头设置',
  setColumnDropdown_title: '列表头',
  setColumnDropdown_confirm: '确认',
  exportButtonTip: '导出 CSV 文件',
  exportModal_current: '导出当前页内容',
  exportModal_all: '导出所有搜索结果',
  exportModal_fields: '选择导出列',
  exportModal_clear: '取消勾选',
  exportModal_selectAll: '全选',
  exportModal_download: '导出',
  exportModal_title: '导出 CSV 文件',
  antdTableLocale: {
    emptyText: '暂无数据'
  },
  filter_selectAllText: '全部',
  selectionModal_total: '已选 {selectedTotal} 项',
  resetColumnWidth: '重置',
  resetColumnWidthTooltip: '重置表格列宽'
};
export default locale;